import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import {
    ShipmentRequestAndItemResponse,
    ShipmentRequestResponse
} from '@/modules/shipments-module/services/shipments.dto'

class ShipmentsRequestFiltererService {
    // Gets a list of pending elements to be sent in a laboratory
    async findPendingToBeSend(
        originLaboratoryId: number,
        filterModel?: CommonFilterModel,
        params?: CommonParams
    ): Promise<IResponseAgGrid<ShipmentRequestResponse>> {
        const response = await axios.put<IResponseAgGrid<ShipmentRequestResponse>>(
            `/shipments/laboratories/${originLaboratoryId}/shipmentRequests`,
            { ...filterModel },
            { params })
        return response.data
    }

    // Returns the summary of pending elements to be sent in a laboratory
    async getPendingToBeSendSummary(
        originLaboratoryId: number
    ): Promise<number> {
        const response = await axios.get<number>(
            `/shipments/laboratories/${originLaboratoryId}/shipmentRequests/summary`)
        return response.data
    }

    // Gets a list of elements by entity label
    async findByLabel(
        originLaboratoryId: number,
        entityLabel: string
    ): Promise<ShipmentRequestAndItemResponse[]> {
        const response = await axios.get<ShipmentRequestAndItemResponse[]>(
            `/shipments/laboratories/${originLaboratoryId}/shipmentRequestAndItems/entityLabel/${entityLabel}`)
        return response.data
    }
}

export const shipmentsRequestFiltererService = new ShipmentsRequestFiltererService()
